module.exports = __webpack_public_path__ + "static/img/ruturns.4247701.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/background/ruturns.png
// module id = YWNa
// module chunks = 1